import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import { handleLogin } from '../../utils/authentication';

interface PrivateRouteState { };

interface PrivateRouteProps {
  component: any;
  isAuthenticated: boolean;
  location: any;
};

class PrivateRoute extends Component<PrivateRouteProps, PrivateRouteState> {

  componentDidMount() {
    handleLogin();
  };

  render() {

    const { component: Component, isAuthenticated, location, ...rest } = this.props;

    if (this.props.isAuthenticated !== null) {
      
      return (
        <Route
          { ...rest }
          render={ props =>
            this.props.isAuthenticated
            ? <Component { ...props } />
            : <Redirect to={ { pathname: '/login', state: { from: props.location } } } />
          }
        />
      );
      
    }

    return null;
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    isAuthenticated: state.auth.success,
    location: ownProps.path
  };
};

export default connect(mapStateToProps, null)(PrivateRoute);